export default __webpack_public_path__ + "static/media/rabbit13.6eed1ebf.gif";